import React from "react";
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const Header = () => {
    return (       
        <header>
            <div className="logoWrapper">
                <StaticImage layout="fullWidth" src="../images/digital-dario-bw.png" alt="a pixelated selfportrait of this web site author"/>
            </div>
            <div className="flexColumnWrapper">
                <span className='title'>Dario Dorella</span>
                <span className='title small'>Digital Product Designer</span>
                <div id="headerLinks" className="flexRowWrapper itemMarginRight">
                    <Link to="/">Home</Link>
                    <a href='https://www.linkedin.com/in/dario-d-7031723/'>Linkedin</a>
                    <a href='mailto:ww72d96rr@mozmail.com?subject=Contact from dariod.netlify.com &body=[ Tell me something :-) ]'>Email</a>
                </div>
            </div>
        </header>
    )
}
export default Header
